export const optionsQuality = [
  {
    id: '1',
    label: 'Nueva',
    value: 'nueva'
  },
  {
    id: '2',
    label: 'Usada',
    value: 'usada'
  }
];
